import { runDemo } from "../shared/demoRunner";
import { createConvolutionScene } from "./scene";

runDemo({ createScene: createConvolutionScene });
